import {makeColorControl} from '../../controls/color-control/color-control';
import {bgColorDescriptor} from '../../controls/color-control/color-control-descriptors';
import type {EmailMakerControl} from '../../right-panel-registry.types';

/** Shared background-color singleton; the control resolves its target from props, so one instance is interchangeable across sectors. */
export const bgColorControl: EmailMakerControl = makeColorControl(bgColorDescriptor);
